import React from 'react';

import { JuridictionViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { JuridictionFormValue } from '../types';
import { buildDto } from '../utils/utils';

import ModalEdition from './ModalEdition';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: JuridictionFormValue = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: JuridictionFormValue) =>
      AdminFonctionnelControllerApi.createJuridictionUsingPOST(
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: JuridictionViolationDtoFormFieldEnum,
      values: JuridictionFormValue,
    ) =>
      AdminFonctionnelControllerApi.validateCreateJuridictionFieldUsingPOST(
        field,
        buildDto(values),
      ),
    response => response.juridictionViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Créer une Juridiction"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
